import { render, staticRenderFns } from "./cri.vue?vue&type=template&id=2b52cf39&scoped=true&"
import script from "./cri.vue?vue&type=script&lang=js&"
export * from "./cri.vue?vue&type=script&lang=js&"
import style0 from "./cri.vue?vue&type=style&index=0&id=2b52cf39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b52cf39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VRow})
